import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { getAllowanceFormValues } from 'src/reducers/clients/allowances';
import selector from 'src/utils/Utils';
import { CLIENT_ALLOWANCE_FORM } from 'src/constants/FormNames';

import Pulldown from 'jbc-front/components/icons/Pulldown';

import { TreeSelectWrapper, TreeUnorderedList, TreeListItem, PullDownIconSection, TreeSelectContainer } from './styles';

const TreeSelect = ({ treeData, employeePaymentMonth, dispatch, placeholder, disabled }) => {
  const [isOpenSelect, setIsOptionSelect] = useState(false);
  const [selectedTree, setSelectedTree] = useState(null);
  const wrapperRef = useRef(null);
  const { t } = useTranslation();

  useEffect(
    () => {
      const handleClickOutside = event => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          setIsOptionSelect(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    },
    [wrapperRef]
  );

  useEffect(
    () => {
      if (employeePaymentMonth) {
        const selectedYear = moment(employeePaymentMonth)
          .year()
          .toString();
        setSelectedTree(selectedYear);
      }
    },
    [employeePaymentMonth]
  );

  const handleOpenSelect = () => {
    setIsOptionSelect(true);
  };

  const handleSelectedTree = tree => {
    setSelectedTree(tree.value === selectedTree ? null : tree.value);
  };

  const handleClickOnChild = child => {
    const { value } = child;
    if (!child.disabled) {
      dispatch(change(CLIENT_ALLOWANCE_FORM, 'employeePaymentMonth', value));
    }
    setIsOptionSelect(false);
  };

  return (
    <TreeSelectContainer onClick={!disabled && handleOpenSelect} ref={wrapperRef} disabled={disabled}>
      {employeePaymentMonth}
      {!employeePaymentMonth && placeholder && !isOpenSelect && <span className="tree-select-placeholder">{placeholder}</span>}

      <PullDownIconSection active={isOpenSelect}>
        <Pulldown />
      </PullDownIconSection>
      {isOpenSelect && (
        <TreeSelectWrapper isOpenSelect={isOpenSelect}>
          {treeData.length > 0
            ? treeData.map(tree => (
                <TreeUnorderedList key={tree.value} onClick={() => handleSelectedTree(tree)} isSelected={selectedTree === tree.value}>
                  {tree.children.length > 0 && <Pulldown />}
                  {tree.title}
                  {selectedTree === tree.value &&
                    tree.children.length > 0 &&
                    tree.children.map(child => (
                      <TreeListItem
                        isActive={child.value === employeePaymentMonth}
                        onClick={() => handleClickOnChild(child)}
                        key={child.value}
                        disabled={child.disabled}
                      >
                        {child.title}
                      </TreeListItem>
                    ))}
                </TreeUnorderedList>
              ))
            : t('features.ClientMotivation.components.TreeSelect.no_data')}
        </TreeSelectWrapper>
      )}
    </TreeSelectContainer>
  );
};

const mapStateToProps = state => ({
  employeePaymentMonth: selector(getAllowanceFormValues(state), 'employeePaymentMonth')
});

export default connect(mapStateToProps)(TreeSelect);
